import styled from 'styled-components'
import { CardText } from '../PageFooter/Footer.styled'

export const CardContainer = styled.div`
  display: flex;
  align-items: flex-start;
  padding: 0 0 1rem 0;
`
export const Icon = styled.img``

export const CardContent = styled.div``
export const CardTitle = styled.h2`
  font-weight: 700;
  font-size: 20px;
  line-height: 24px;
  padding: 8px 0 8px 12px;
  margin: 0;
`
export const FeatureCardText = styled(CardText)`
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  padding: 0px 0 8px 12px;
`
